import Vue from "vue";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountRegister from "@Scripts/Components/Account/AccountRegister.vue";
import AccountEdit from "@Scripts/Components/Account/AccountEdit.vue";
import AccountEmailConfirmSend from "@Scripts/Components/Account/AccountEmailConfirmSend.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";

import ProfileEdit from "@Scripts/Components/Customer/ProfileEdit.vue";

import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import InfoRequestButton from "@Scripts/Components/InfoRequest/InfoRequestButton.vue";
import InfoRequestDialog from "@Scripts/Components/InfoRequest/InfoRequestDialog.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountregister", AccountRegister);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountemailconfirmsend", AccountEmailConfirmSend);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);

        Vue.component("app-profileedit", ProfileEdit);

        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-inforequestbutton", InfoRequestButton);
        Vue.component("app-inforequestdialog", InfoRequestDialog);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}